<template>
	<div  v-wechat-title="this.scontenttitle+' 在线阅读'">
		<Header>
			<div class="leftcss"><router-link :to="'daozang'+this.$route.params.nid+'-'+this.$route.params.tid"><i class="iconfont icon---"></i></router-link></div>
			<div class="centercss">{{scontenttitle}}</div>
			<div class="crightcss"><span id="show-modal" @click="showModal = true"><i class="iconfont icon-zhedie1"></i></span><modal v-if="showModal" @close="showModal = false" > </modal></div>
		</Header>
		<div class="sbody-main" v-html="scontentarr.sc">
		</div>
		<GoTop />
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import GoTop from '@/components/gotop.vue'
	import modal from '@/components/modal.vue'
	import axios from 'axios'
	export default {
		data() {
			return {
				showModal: false,
				scontenttitle:'',
				scontentarr: [],

			}
		},
		components: {
			Header,
			GoTop,
			modal 
		},
		mounted() {
			this.getscontent();
		},
		methods: {
			getscontent: function() {
				var _self = this;
				axios.get('https://m.daorenjia.com/api/apiscontent.php?nid='+ this.$route.params.nid+'&tid=' + this.$route.params.tid + '&id=' + this.$route.params.id).then(
					function(response) {
						//console.log(response);
						_self.scontenttitle = response.data[0];
						_self.scontentarr = response.data[1];

					})
			},

		}


	}
</script>
<style>
.sbody-main {
		margin: 0 4vw 0 4vw;
		padding: 0;
		 font-family: dzfont;
		 
	}
</style>
